import styled, {css} from "styled-components"

import Selector, {SelectorProps} from "@irati/ui/src/Selector"
import Flex from "@irati/ui/src/Flex"
import Card from "@irati/ui/src/Layout/Card"
import Modal from "@irati/ui/src/GenericModal"
import SectionHeader from "../../SectionHeader"

interface SelectorComponentProps extends SelectorProps {
  selected: boolean
}

export const CategorySelector = styled(Selector)<SelectorComponentProps>`
  ${({theme, selected}) => css`
    background-color: ${selected ? theme.colors.primary2 : theme.colors.utility.white};
    color: ${selected ? theme.colors.utility.white : theme.colors.primary2};
    margin-bottom: ${theme.spacing.two};
    &:hover {
      background-color: ${selected ? theme.colors.primary2 : theme.colors.utility.white};
    }
  `}
`

export const EditSelector = styled(Selector)<SelectorProps>`
  ${({theme}) => css`
    background-color: ${theme.colors.primary2_50};
    margin-bottom: ${theme.spacing.two};
  `}
`

export const StyledHeader = styled(SectionHeader)`
  ${({theme}) => css`
    margin-top: 0;
    margin-bottom: ${theme.spacing.two};
    ${theme.mediaQueries.maxWidthMedia.tablet`
      margin-bottom: ${theme.spacing.one};
    `}
  `}
`

export const CategoriesWrapper = styled(Flex)`
  flex-wrap: wrap;
  overflow-x: auto;
  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    flex-wrap: nowrap;
    margin-left: -${theme.spacing.two};
    margin-right: -${theme.spacing.two};
    padding-left: ${theme.spacing.two};
    overflow-x: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  `}
`

export const NoDealsWrapper = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.utility.highlight}
    margin-bottom: ${theme.spacing.half};
    padding-top: 160px;
  `}
`

export const NoDealsEmptyImage = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.utility.contrast};
    border-radius: 3px;
    height: ${theme.spacing.ten};
    left: ${theme.spacing.four};
    position: absolute;
    top: 120px;
    width: ${theme.spacing.ten};
  `}
`

export const NoDealsText = styled(Card)`
  ${({theme}) => css`
    border-radius: 0 0 3px 3px;
    padding-top: ${theme.spacing.seven};
  `}
`

export const StyledModal = styled(Modal)`
  top: 50%;
  transform: translateY(-50%);
  .modal-dialog {
    width: 480px;
  }
`
